import { render, staticRenderFns } from "./InquiryFormTicketing.vue?vue&type=template&id=70e85ea1&"
import script from "./InquiryFormTicketing.vue?vue&type=script&lang=js&"
export * from "./InquiryFormTicketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports